import { compose, withHandlers, withPropsOnChange } from 'recompose';
import moment from 'moment';
import qs from 'query-string';
import { isFunction } from 'lodash';

export default ({
  //  fromFilter = 'stop_time__gte',
  //  toFilter = 'stop_time__lt',
  fromFilter = 'from_date',
  toFilter = 'to_date',
  defaultDates: defaultDatesFn,
} = {}) =>
  compose(
    withPropsOnChange(['location', 'filters'], props => {
      const { location } = props;
      const today = moment().startOf('day');
      const defaultDates = isFunction(defaultDatesFn)
        ? defaultDatesFn(props)
        : {
            fromDate: undefined, //moment().startOf('year'),
            toDate: undefined,
          };
      // const tmpFromDate = moment(
      //   qs.parse(location.search).from_date,
      //   'YYYY-MM-DD',
      //   true
      // );
      // const tmpToDate = moment(
      //   qs.parse(location.search).to_date,
      //   'YYYY-MM-DD',
      //   true
      // );
      // const fromDate = tmpFromDate.isValid()
      //   ? tmpFromDate
      //   : defaultDates.fromDate;
      // const toDate = tmpToDate.isValid() ? tmpToDate : defaultDates.toDate;

      const tmpFromDate = moment(
        props.filters.from_date,
        'YYYY-MM-DD',
        true
      );
      const tmpToDate = moment(
        props.filters.to_date,
        'YYYY-MM-DD',
        true
      );
      const fromDate = tmpFromDate.isValid()
        ? tmpFromDate
        : defaultDates.fromDate;
      const toDate = tmpToDate.isValid()
        ? tmpToDate
        : defaultDates.toDate;

      console.log(props.filters);

      return {
        fromDate,
        toDate,
        filters: {
          ...(props.filters || {}),
          [fromFilter]: fromDate == undefined ? undefined : moment(fromDate).format('YYYY-MM-DD'),
          [toFilter]: toDate == undefined ? undefined : moment(toDate).format('YYYY-MM-DD'),
        },
      };
    }),
    // withHandlers({
    //   setFromDate: ({ history, location }) => date => {
    //     if (!date) return;
    //
    //     history.replace({
    //       search: qs.stringify({
    //         ...qs.parse(location.search),
    //         from_date: date.format('YYYY-MM-DD'),
    //       }),
    //     });
    //   },
    //   setToDate: ({ history, location }) => date => {
    //     if (!date) return;
    //
    //     history.replace({
    //       search: qs.stringify({
    //         ...qs.parse(location.search),
    //         to_date: date.format('YYYY-MM-DD'),
    //       }),
    //     });
    //   },
    // })
  );



// WEBPACK FOOTER //
// ./src/components/common/Tables/withDateRange.js